module.exports = __webpack_public_path__ + "img/ipad-composite_en.4859898.jpg";